/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

export const NamespacesApiEnum = {
    GET_NAMESPACES: (orgId: string): string => {
        return `/organisations/${orgId}/namespaces`;
    },
    GET_NAMESPACE: (orgId: string, id: string): string => {
        return `/organisations/${orgId}/namespaces/${id}`;
    },
    CREATE_NAMESPACE: (orgId: string): string => {
        return `/organisations/${orgId}/namespaces`;
    },
    PATCH_NAMESPACE: (orgId: string, id: string): string => {
        return `/organisations/${orgId}/namespaces/${id}`;
    },
    DELETE_NAMESPACE: (orgId: string, id: string): string => {
        return `/organisations/${orgId}/namespaces/${id}`;
    },
};
